import { AxiosError, AxiosResponse } from 'axios';
import { ApiErrorModel } from '../model/ApiError.model';
import { HttpQueryConfig, HttpQueryError } from '../model/HttpQueryConfig.model';

export const createQueryErrorMapFromAllQueries = (queryConfig: HttpQueryConfig): HttpQueryError[] => {
  return Object.values(queryConfig).map(query => Object.values(query.errors)).flat();
};

export const extractErrorMessageFromError = (thrownError: Error, queriesConfig: HttpQueryConfig | null): string => {
  const defaultErrorMessage = 'Skontaktuj się z administratorem';

  if (!queriesConfig) {
    return defaultErrorMessage;
  }

  const queryErrorMap = createQueryErrorMapFromAllQueries(queriesConfig);

  if ((thrownError instanceof AxiosError) && thrownError.response) {
    const response: AxiosError<ApiErrorModel>['response'] = thrownError.response;

    const errorCodeInThrownError: string = thrownError?.response?.data.errorCode;
    const foundError = queryErrorMap.find(error => error.status === response.status && errorCodeInThrownError === error.errorCode);

    if (foundError) {
      return foundError.errorCode;
    }
  }

  return defaultErrorMessage;
};

export const extractTotalCountHeaderFromAxiosHeader = (response: AxiosResponse): number => {
  if (typeof response.headers.get === 'function') {
    const result = response.headers.get('total');
    if (typeof result === 'string') {
      const numberResult = parseInt(result);
      if (!isNaN(numberResult)) {
        return numberResult;
      }
    }
  }
  return 0;
}